import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import es from 'vuetify/lib/locale/es';
import '@fortawesome/fontawesome-free/css/all.css';
import 'vuetify/dist/vuetify.min.css';
Vue.use(Vuetify);


export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        background: '#FFFDFB',
        surface: '#FFFDFB',
        'text-primary': '#cfcfcf',
        'surface-bright': '#37424a',
        'surface-light': '#37424a',
        'surface-variant': '#485660',
        'on-surface-variant': '#EEEEEE',
        primary: '#C44014',
        border: '#EEEEEE',
        'primary-darken-1': '#C44014',
        secondary: '#FE7547',
        'secondary-darken-1': '#018786',
        error: '#FF4F4F',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#ffc200',
    
        cacique: '#C44014',
        atardecer: '#FE7547',
        blackColor: '#140804',
        whiteColor: '#FFFDFB',
        boxesColor: '#FFF8EE',
        insideBoxColor: '#FFE4BC',
        altarQColor: '#FFD0AD',
        merendon: '#167132',
        pino: '#65DC8C',
        orquidea: '#E4ACFF',
        ancestral: '#4A2559',
        utila: '#43B1FE',
        yojoa: '#134264',
        icons2: '#DBA391',
      },
      dark: {
        background: '#FFFDFB',
        surface: '#FFFDFB',
        'text-primary': '#cfcfcf',
        'surface-bright': '#37424a',
        'surface-light': '#37424a',
        'surface-variant': '#485660',
        'on-surface-variant': '#EEEEEE',
        primary: '#C44014',
        border: '#EEEEEE',
        'primary-darken-1': '#C44014',
        secondary: '#FE7547',
        'secondary-darken-1': '#018786',
        error: '#FF4F4F',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#ffc200',
    
        cacique: '#C44014',
        atardecer: '#FE7547',
        blackColor: '#140804',
        whiteColor: '#FFFDFB',
        boxesColor: '#FFF8EE',
        insideBoxColor: '#FFE4BC',
        altarQColor: '#FFD0AD',
        merendon: '#167132',
        pino: '#65DC8C',
        orquidea: '#E4ACFF',
        ancestral: '#4A2559',
        utila: '#43B1FE',
        yojoa: '#134264',
        icons2: '#DBA391',
      },
    },
  },
  lang: {
    current: "es",
  },
  icons: {
    iconfont: "fa",
  },
});
